import { Resource } from "react-admin";
import InstallationIcon from "@material-ui/icons/CloudQueue";
import React from "react";

import List from "./List";
import Show from "./Show";
// import Edit from "./Edit";
import PermissionDenied from "../../components/PermissionDenied";
import { POLICY_INSTALLATIONS } from "../../common/rolesManagement";
// import Delete from "./Delete";

export default permissions => (
    <Resource
        name="installations"
        icon={InstallationIcon}
        list={
            permissions && permissions.includes(POLICY_INSTALLATIONS.READ)
                ? List
                : PermissionDenied
        }
        show={
            permissions && permissions.includes(POLICY_INSTALLATIONS.READ)
                ? Show
                : PermissionDenied
        }
    />
);



// WEBPACK FOOTER //
// ./src/resources/Installations/index.js